module.exports = __webpack_public_path__ + "static/media/equal-light.1cc9fa1e.svg";